import React from 'react';
import './home.scss';

export const RowItemGame = (props: any) =>
{
    // const imgListFull = [...Array(41)].map((x, i) => i + 10);
    // const imgListNum = [...Array(10)].map((x, i) => i);
    const imgListChar = [...Array(26)].map((x, i) => i + 12);
    const widthScreen = props.widthScreen;
    const hightScreen = props.hightScreen;
    const ImgListMoving = imgListChar.map((v, index) =>
    {
        const tmpI = (Math.floor(Math.random() * 9));
        const imgSrc = 'images/so-' + tmpI + '.png';
        return (
            <div key={index} className="ringMoving">
                <img src={imgSrc} alt={"So 01" + tmpI} className={'icon-img-style'} style={{ height: hightScreen>820 ? '80%': '67%'}}/>
            </div>
        );
    });
    /* eslint-disable */
    const ImgListInit = imgListChar.map((v, index) =>
    {
        const tmpI1 = (Math.floor(Math.random() * 9));
        const imgSrc = 'images/so-' + tmpI1 + '.png';
        return v !== 12 && v !== 16 && v !== 20 ? (
            <div key={index} className="ringEnd" >
                <img src={imgSrc} alt={"So 01" + tmpI1} className={'icon-img-style'}/>
            </div>
        ) : null;
    });
    const ImgListInit2 = imgListChar.map((v, index) =>
    {
        const tmpI2 = (Math.floor(Math.random() * 9));
        const imgSrc = 'images/so-' + tmpI2 + '.png';
        return (
            <div key={index} className="ringEnd" style={{ paddingLeft: widthScreen >= 400 ? 5 + hightScreen / widthScreen + 'px' : '0px' }}>
                <img src={imgSrc} alt={"So 01" + tmpI2} className={'icon-img-style' }/>
            </div>
        );
    });
    const ImgListInit3 = imgListChar.map((v, index) =>
    {
        const tmpI3 = (Math.floor(Math.random() * 9));
        const imgSrc = 'images/so-' + tmpI3 + '.png';
        return (
            <div key={index} className="ringEnd" style={{ paddingLeft: widthScreen >= 400 ? 5 + hightScreen / widthScreen + 'px' : '0px' }}>
                <img src={imgSrc} alt={"So 01" + tmpI3} className={'icon-img-style'}/>
            </div>
        );
    });

    if (!props.spin && props.prize === 0) {
        switch (props.type) {
            case 'ring1':
                return <>{ImgListInit}</>;
            case 'ring2':
                return <>{ImgListInit2}</>;
            case 'ring3':
                return <>{ImgListInit3}</>;
            default:
                return (
                    <>
                        <div className="ringEnd">
                            <img src="images/so-13.png" alt="So 01" className="icon-img-style" style={{ height: hightScreen > 820 ? '80%' : '67%' }}/>
                        </div>
                        <div className="ringEnd">
                            <img src="images/so-14.png" alt="So 01" className="icon-img-style" style={{ height: hightScreen > 820 ? '80%' : '67%' }}/>
                        </div>
                        <div className="ringEnd">
                            <img src="images/so-15.png" alt="So 01" className="icon-img-style" style={{ height: hightScreen > 820 ? '80%' : '67%' }}/>
                        </div>
                        <div className="ringEnd">
                            <img src="images/so-16.png" alt="So 02" className="icon-img-style" style={{ height: hightScreen > 820 ? '80%' : '67%' }}/>
                        </div>
                        <div className="ringEnd">
                            <img src="images/so-17.png" alt="So 03" className="icon-img-style" style={{ height: hightScreen > 820 ? '80%' : '67%' }}/>
                        </div>
                        <div className="ringEnd">
                            <img src="images/so-18.png" alt="So 04" className="icon-img-style" style={{ height: hightScreen > 820 ? '80%' : '67%' }}/>
                        </div>
                        <div className="ringEnd">
                            <img src="images/so-19.png" alt="So 04" className="icon-img-style" style={{ height: hightScreen > 820 ? '80%' : '67%' }} />
                        </div>
                        <div className="ringEnd">
                            <img src="images/so-20.png" alt="So 04" className="icon-img-style" style={{ height: hightScreen > 820 ? '80%' : '67%' }} />
                        </div>
                        <div className="ringEnd">
                            <img src="images/so-21.png" alt="So 04" className="icon-img-style" style={{ height: hightScreen > 820 ? '80%' : '67%' }}/>
                        </div>
                        <div className="ringEnd">
                            <img src="images/so-22.png" alt="So 04" className="icon-img-style" style={{ height: hightScreen > 820 ? '80%' : '67%' }} />
                        </div>
                        <div className="ringEnd">
                            <img src="images/so-23.png" alt="So 04" className="icon-img-style" style={{ height: hightScreen > 820 ? '80%' : '67%' }} />
                        </div>
                        <div className="ringEnd">
                            <img src="images/so-24.png" alt="So 04" className="icon-img-style" style={{ height: hightScreen > 820 ? '80%' : '67%' }} />
                        </div>
                        <div className="ringEnd">
                            <img src="images/so-25.png" alt="So 04" className="icon-img-style" style={{ height: hightScreen > 820 ? '80%' : '67%' }} />
                        </div>
                        <div className="ringEnd">
                            <img src="images/so-26.png" alt="So 04" className="icon-img-style" style={{ height: hightScreen > 820 ? '80%' : '67%' }} />
                        </div>
                        <div className="ringEnd">
                            <img src="images/so-27.png" alt="So 04" className="icon-img-style" style={{ height: hightScreen > 820 ? '80%' : '67%' }} />
                        </div>
                        <div className="ringEnd">
                            <img src="images/so-28.png" alt="So 04" className="icon-img-style" style={{ height: hightScreen > 820 ? '80%' : '67%' }} />
                        </div>
                        <div className="ringEnd">
                            <img src="images/so-29.png" alt="So 04" className="icon-img-style" style={{ height: hightScreen > 820 ? '80%' : '67%' }} />
                        </div>
                        <div className="ringEnd">
                            <img src="images/so-30.png" alt="So 04" className="icon-img-style" style={{ height: hightScreen > 820 ? '80%' : '67%' }} />
                        </div>
                        <div className="ringEnd">
                            <img src="images/so-31.png" alt="So 04" className="icon-img-style" style={{ height: hightScreen > 820 ? '80%' : '67%' }} />
                        </div>
                        <div className="ringEnd">
                            <img src="images/so-32.png" alt="So 04" className="icon-img-style" style={{ height: hightScreen > 820 ? '80%' : '67%' }} />
                        </div>
                        <div className="ringEnd">
                            <img src="images/so-33.png" alt="So 04" className="icon-img-style" style={{ height: hightScreen > 820 ? '80%' : '67%' }} />
                        </div>
                        <div className="ringEnd">
                            <img src="images/so-34.png" alt="So 04" className="icon-img-style" style={{ height: hightScreen > 820 ? '80%' : '67%' }} />
                        </div>
                        <div className="ringEnd">
                            <img src="images/so-35.png" alt="So 04" className="icon-img-style" style={{ height: hightScreen > 820 ? '80%' : '67%' }} />
                        </div>
                        <div className="ringEnd">
                            <img src="images/so-36.png" alt="So 04" className="icon-img-style" style={{ height: hightScreen > 820 ? '80%' : '67%' }} />
                        </div>
                        <div className="ringEnd">
                            <img src="images/so-37.png" alt="So 04" className="icon-img-style" style={{ height: hightScreen > 820 ? '80%' : '67%' }} />
                        </div>
                    </>
                );
        }
    } else if (
        props.spin &&
        (props.ring1 === 0 ||
            props.ring2 === 0 ||
            props.ring3 === 0 ||
            props.ring1 === undefined ||
            props.ring2 === undefined ||
            props.ring3 === undefined)
    ) {
        return <>{ImgListMoving}</>;
    } else if (
        (props.ring1 === 1) ||
        (props.ring2 === 1) ||
        (props.ring3 === 1)
    ) {
        switch (props.type) {
            case 'ring1':
                return (
                    <>
                        <div className="ringEnd">
                            <img src="images/so-30.png" alt="So 01" className="icon-img-style" style={{ height: hightScreen > 820 ? '80%' : '67%' }}/>
                        </div>
                        <div className="ringEnd">
                            <img src="images/so-1.png" alt="So 01" className="icon-img-style" style={{ height: hightScreen > 820 ? '80%' : '67%' }}/>
                        </div>
                        <div className="ringEnd">
                            <img src="images/so-32.png" alt="So 01" className="icon-img-style" style={{ height: hightScreen > 820 ? '80%' : '67%' }}/>
                        </div>
                        <div className="ringEnd">
                            <img src="images/so-33.png" alt="So 01" className="icon-img-style" style={{ height: hightScreen > 820 ? '80%' : '67%' }}/>
                        </div>
                    </>
                );
            case 'ring2':
                return (
                    <>
                        <div className="ringEnd">
                            <img src="images/so-15.png" alt="So 01" className="icon-img-style" style={{ height: hightScreen > 820 ? '80%' : '67%' }}/>
                        </div>
                        <div className="ringEnd">
                            <img src="images/so-1.png" alt="So 01" className="icon-img-style" style={{ height: hightScreen > 820 ? '80%' : '67%' }}/>
                        </div>
                        <div className="ringEnd">
                            <img src="images/so-17.png" alt="So 01" className="icon-img-style" style={{ height: hightScreen > 820 ? '80%' : '67%' }}/>
                        </div>
                        <div className="ringEnd">
                            <img src="images/so-18.png" alt="So 01" className="icon-img-style" style={{ height: hightScreen > 820 ? '80%' : '67%' }}/>
                        </div>
                    </>
                );
            case 'ring3':
                return (
                    <>
                        <div className="ringEnd">
                            <img src="images/so-24.png" alt="So 01" className="icon-img-style" style={{ height: hightScreen > 820 ? '80%' : '67%' }}/>
                        </div>
                        <div className="ringEnd">
                            <img src="images/so-1.png" alt="So 01" className="icon-img-style" style={{ height: hightScreen > 820 ? '80%' : '67%' }}/>
                        </div>
                        <div className="ringEnd">
                            <img src="images/so-26.png" alt="So 01" className="icon-img-style" style={{ height: hightScreen > 820 ? '80%' : '67%' }}/>
                        </div>
                        <div className="ringEnd">
                            <img src="images/so-27.png" alt="So 01" className="icon-img-style" style={{ height: hightScreen > 820 ? '80%' : '67%' }}/>
                        </div>
                    </>
                );
            default:
                break;
        }
        return <>{ImgListInit}</>;
    } else if (
        (props.ring1 === 2) ||
        (props.ring2 === 2) ||
        (props.ring3 === 2)
    ) {
        switch (props.type) {
            case 'ring1':
                return (
                    <>
                        <div className="ringEnd">
                            <img src="images/so-37.png" alt="So 01" className="icon-img-style" style={{ height: hightScreen > 820 ? '80%' : '67%' }}/>
                        </div>
                        <div className="ringEnd">
                            <img src="images/so-2.png" alt="So 01" className="icon-img-style" />
                        </div>
                        <div className="ringEnd">
                            <img src="images/so-22.png" alt="So 01" className="icon-img-style" style={{ height: hightScreen > 820 ? '80%' : '67%' }}/>
                        </div>
                        <div className="ringEnd">
                            <img src="images/so-23.png" alt="So 01" className="icon-img-style" style={{ height: hightScreen > 820 ? '80%' : '67%' }}/>
                        </div>
                    </>
                );
            case 'ring2':
                return (
                    <>
                        <div className="ringEnd">
                            <img src="images/so-25.png" alt="So 01" className="icon-img-style" style={{ height: hightScreen > 820 ? '80%' : '67%' }}/>
                        </div>
                        <div className="ringEnd">
                            <img src="images/so-2.png" alt="So 01" className="icon-img-style" />
                        </div>
                        <div className="ringEnd">
                            <img src="images/so-26.png" alt="So 01" className="icon-img-style" style={{ height: hightScreen > 820 ? '80%' : '67%' }}/>
                        </div>
                        <div className="ringEnd">
                            <img src="images/so-27.png" alt="So 01" className="icon-img-style" style={{ height: hightScreen > 820 ? '80%' : '67%' }}/>
                        </div>
                    </>
                );
            case 'ring3':
                return (
                    <>
                        <div className="ringEnd">
                            <img src="images/so-15.png" alt="So 01" className="icon-img-style" style={{ height: hightScreen > 820 ? '80%' : '67%' }}/>
                        </div>
                        <div className="ringEnd">
                            <img src="images/so-2.png" alt="So 01" className="icon-img-style" />
                        </div>
                        <div className="ringEnd">
                            <img src="images/so-16.png" alt="So 01" className="icon-img-style" style={{ height: hightScreen > 820 ? '80%' : '67%' }}/>
                        </div>
                        <div className="ringEnd">
                            <img src="images/so-17.png" alt="So 01" className="icon-img-style" style={{ height: hightScreen > 820 ? '80%' : '67%' }} />
                        </div>
                    </>
                );
            default:
                break;
        }
        return (
            <>
                {/* {ImgListInit} */}
                <div className="ringEnd">
                    <img src="images/so-10.png" alt="So 01" className="icon-img-style" style={{ height: hightScreen > 820 ? '80%' : '67%' }}/>
                </div>
                <div className="ringEnd">
                    <img src="images/so-11.png" alt="So 01" className="icon-img-style" style={{ height: hightScreen > 820 ? '80%' : '67%' }}/>
                </div>
                <div className="ringEnd">
                    <img src="images/so-12.png" alt="So 01" className="icon-img-style" style={{ height: hightScreen > 820 ? '80%' : '67%' }}/>
                </div>
                <div className="ringEnd">
                    <img src="images/so-13.png" alt="So 01" className="icon-img-style" style={{ height: hightScreen > 820 ? '80%' : '67%' }}/>
                </div>
                <div className="ringEnd">
                    <img src="images/so-14.png" alt="So 01" className="icon-img-style" style={{ height: hightScreen > 820 ? '80%' : '67%' }}/>
                </div>
                <div className="ringEnd">
                    <img src="images/so-15.png" alt="So 01" className="icon-img-style" style={{ height: hightScreen > 820 ? '80%' : '67%' }}/>
                </div>
                <div className="ringEnd">
                    <img src="images/so-18.png" alt="So 01" className="icon-img-style" style={{ height: hightScreen > 820 ? '80%' : '67%' }}/>
                </div>
                <div className="ringEnd">
                    <img src="images/so-29.png" alt="So 01" className="icon-img-style" style={{ height: hightScreen > 820 ? '80%' : '67%' }}/>
                </div>
            </>
        );
    } else if (
        (props.ring1 === 3) ||
        (props.ring2 === 3) ||
        (props.ring3 === 3)
    ) {
        switch (props.type) {
            case 'ring1':
                return (
                    <>
                        <div className="ringEnd">
                            <img src="images/so-37.png" alt="So 01" className="icon-img-style" style={{ height: hightScreen > 820 ? '80%' : '67%' }}/>
                        </div>
                        <div className="ringEnd">
                            <img src="images/so-3.png" alt="So 01" className="icon-img-style" />
                        </div>
                        <div className="ringEnd">
                            <img src="images/so-35.png" alt="So 01" className="icon-img-style" style={{ height: hightScreen > 820 ? '80%' : '67%' }}/>
                        </div>
                        <div className="ringEnd">
                            <img src="images/so-34.png" alt="So 01" className="icon-img-style" style={{ height: hightScreen > 820 ? '80%' : '67%' }}/>
                        </div>
                    </>
                );
            case 'ring2':
                return (
                    <>
                        <div className="ringEnd">
                            <img src="images/so-19.png" alt="So 01" className="icon-img-style" style={{ height: hightScreen > 820 ? '80%' : '67%' }}/>
                        </div>
                        <div className="ringEnd">
                            <img src="images/so-3.png" alt="So 01" className="icon-img-style" />
                        </div>
                        <div className="ringEnd">
                            <img src="images/so-21.png" alt="So 01" className="icon-img-style" style={{ height: hightScreen > 820 ? '80%' : '67%' }}/>
                        </div>
                        <div className="ringEnd">
                            <img src="images/so-22.png" alt="So 01" className="icon-img-style" style={{ height: hightScreen > 820 ? '80%' : '67%' }}/>
                        </div>
                    </>
                );
            case 'ring3':
                return (
                    <>
                        <div className="ringEnd">
                            <img src="images/so-30.png" alt="So 01" className="icon-img-style" style={{ height: hightScreen > 820 ? '80%' : '67%' }}/>
                        </div>
                        <div className="ringEnd">
                            <img src="images/so-3.png" alt="So 01" className="icon-img-style" />
                        </div>
                        <div className="ringEnd">
                            <img src="images/so-31.png" alt="So 01" className="icon-img-style" style={{ height: hightScreen > 820 ? '80%' : '67%' }}/>
                        </div>
                        <div className="ringEnd">
                            <img src="images/so-33.png" alt="So 01" className="icon-img-style" style={{ height: hightScreen > 820 ? '80%' : '67%' }}/>
                        </div>
                    </>
                );
        }
        return (
            <>
                <div className="ringEnd">
                    <img src="images/so-0.png" alt="So 01" className="icon-img-style" style={{ height: hightScreen > 820 ? '80%' : '67%' }}/>
                </div>
                <div className="ringEnd">
                    <img src="images/so-4.png" alt="So 01" className="icon-img-style" />
                </div>
                <div className="ringEnd">
                    <img src="images/so-02.png" alt="So 01" className="icon-img-style" style={{ height: hightScreen > 820 ? '80%' : '67%' }}/>
                </div>
                <div className="ringEnd">
                    <img src="images/so-03.png" alt="So 01" className="icon-img-style" style={{ height: hightScreen > 820 ? '80%' : '67%' }}/>
                </div>
            </>
        );
    }
    else if (
        (props.ring1 === 4) ||
        (props.ring2 === 4) ||
        (props.ring3 === 4)
    ) {
        switch (props.type) {
            case 'ring1':
                return (
                    <>
                        <div className="ringEnd">
                            <img src="images/so-37.png" alt="So 01" className="icon-img-style" style={{ height: hightScreen > 820 ? '80%' : '67%' }}/>
                        </div>
                        <div className="ringEnd">
                            <img src="images/so-4.png" alt="So 01" className="icon-img-style" />
                        </div>
                        <div className="ringEnd">
                            <img src="images/so-35.png" alt="So 01" className="icon-img-style" style={{ height: hightScreen > 820 ? '80%' : '67%' }}/>
                        </div>
                        <div className="ringEnd">
                            <img src="images/so-34.png" alt="So 01" className="icon-img-style" style={{ height: hightScreen > 820 ? '80%' : '67%' }}/>
                        </div>
                    </>
                );
            case 'ring2':
                return (
                    <>
                        <div className="ringEnd">
                            <img src="images/so-19.png" alt="So 01" className="icon-img-style" style={{ height: hightScreen > 820 ? '80%' : '67%' }}/>
                        </div>
                        <div className="ringEnd">
                            <img src="images/so-4.png" alt="So 01" className="icon-img-style" />
                        </div>
                        <div className="ringEnd">
                            <img src="images/so-21.png" alt="So 01" className="icon-img-style" style={{ height: hightScreen > 820 ? '80%' : '67%' }}/>
                        </div>
                        <div className="ringEnd">
                            <img src="images/so-22.png" alt="So 01" className="icon-img-style" style={{ height: hightScreen > 820 ? '80%' : '67%' }}/>
                        </div>
                    </>
                );
            case 'ring3':
                return (
                    <>
                        <div className="ringEnd">
                            <img src="images/so-30.png" alt="So 01" className="icon-img-style" style={{ height: hightScreen > 820 ? '80%' : '67%' }}/>
                        </div>
                        <div className="ringEnd">
                            <img src="images/so-4.png" alt="So 01" className="icon-img-style" />
                        </div>
                        <div className="ringEnd">
                            <img src="images/so-31.png" alt="So 01" className="icon-img-style" style={{ height: hightScreen > 820 ? '80%' : '67%' }}/>
                        </div>
                        <div className="ringEnd">
                            <img src="images/so-33.png" alt="So 01" className="icon-img-style" style={{ height: hightScreen > 820 ? '80%' : '67%' }}/>
                        </div>
                    </>
                );
        }
        return (
            <>
                <div className="ringEnd">
                    <img src="images/so-0.png" alt="So 01" className="icon-img-style" style={{ height: hightScreen > 820 ? '80%' : '67%' }}/>
                </div>
                <div className="ringEnd">
                    <img src="images/so-4.png" alt="So 01" className="icon-img-style" />
                </div>
                <div className="ringEnd">
                    <img src="images/so-02.png" alt="So 01" className="icon-img-style" style={{ height: hightScreen > 820 ? '80%' : '67%' }}/>
                </div>
                <div className="ringEnd">
                    <img src="images/so-03.png" alt="So 01" className="icon-img-style" style={{ height: hightScreen > 820 ? '80%' : '67%' }}/>
                </div>
            </>
        );
    }

    else if (
        (props.ring1 === 5) ||
        (props.ring2 === 5) ||
        (props.ring3 === 5)
    ) {
        switch (props.type) {
            case 'ring1':
                return (
                    <>
                        <div className="ringEnd">
                            <img src="images/so-37.png" alt="So 01" className="icon-img-style" style={{ height: hightScreen > 820 ? '80%' : '67%' }}/>
                        </div>
                        <div className="ringEnd">
                            <img src="images/so-5.png" alt="So 01" className="icon-img-style" />
                        </div>
                        <div className="ringEnd">
                            <img src="images/so-35.png" alt="So 01" className="icon-img-style" style={{ height: hightScreen > 820 ? '80%' : '67%' }}/>
                        </div>
                        <div className="ringEnd">
                            <img src="images/so-34.png" alt="So 01" className="icon-img-style" style={{ height: hightScreen > 820 ? '80%' : '67%' }}/>
                        </div>
                    </>
                );
            case 'ring2':
                return (
                    <>
                        <div className="ringEnd">
                            <img src="images/so-19.png" alt="So 01" className="icon-img-style" style={{ height: hightScreen > 820 ? '80%' : '67%' }}/>
                        </div>
                        <div className="ringEnd">
                            <img src="images/so-5.png" alt="So 01" className="icon-img-style" />
                        </div>
                        <div className="ringEnd">
                            <img src="images/so-21.png" alt="So 01" className="icon-img-style" style={{ height: hightScreen > 820 ? '80%' : '67%' }}/>
                        </div>
                        <div className="ringEnd">
                            <img src="images/so-22.png" alt="So 01" className="icon-img-style" style={{ height: hightScreen > 820 ? '80%' : '67%' }}/>
                        </div>
                    </>
                );
            case 'ring3':
                return (
                    <>
                        <div className="ringEnd">
                            <img src="images/so-30.png" alt="So 01" className="icon-img-style" style={{ height: hightScreen > 820 ? '80%' : '67%' }}/>
                        </div>
                        <div className="ringEnd">
                            <img src="images/so-5.png" alt="So 01" className="icon-img-style" />
                        </div>
                        <div className="ringEnd">
                            <img src="images/so-31.png" alt="So 01" className="icon-img-style" style={{ height: hightScreen > 820 ? '80%' : '67%' }}/>
                        </div>
                        <div className="ringEnd">
                            <img src="images/so-33.png" alt="So 01" className="icon-img-style" style={{ height: hightScreen > 820 ? '80%' : '67%' }}/>
                        </div>
                    </>
                );
        }
        return (
            <>
                <div className="ringEnd">
                    <img src="images/so-0.png" alt="So 01" className="icon-img-style" style={{ height: hightScreen > 820 ? '80%' : '67%' }}/>
                </div>
                <div className="ringEnd">
                    <img src="images/so-5.png" alt="So 01" className="icon-img-style" />
                </div>
                <div className="ringEnd">
                    <img src="images/so-02.png" alt="So 01" className="icon-img-style" style={{ height: hightScreen > 820 ? '80%' : '67%' }}/>
                </div>
                <div className="ringEnd">
                    <img src="images/so-03.png" alt="So 01" className="icon-img-style" style={{ height: hightScreen > 820 ? '80%' : '67%' }}/>
                </div>
            </>
        );
    }

    else if (
        (props.ring1 === 6) ||
        (props.ring2 === 6) ||
        (props.ring3 === 6)
    ) {
        switch (props.type) {
            case 'ring1':
                return (
                    <>
                        <div className="ringEnd">
                            <img src="images/so-37.png" alt="So 01" className="icon-img-style" style={{ height: hightScreen > 820 ? '80%' : '67%' }}/>
                        </div>
                        <div className="ringEnd">
                            <img src="images/so-6.png" alt="So 01" className="icon-img-style" />
                        </div>
                        <div className="ringEnd">
                            <img src="images/so-35.png" alt="So 01" className="icon-img-style" style={{ height: hightScreen > 820 ? '80%' : '67%' }}/>
                        </div>
                        <div className="ringEnd">
                            <img src="images/so-34.png" alt="So 01" className="icon-img-style" style={{ height: hightScreen > 820 ? '80%' : '67%' }}/>
                        </div>
                    </>
                );
            case 'ring2':
                return (
                    <>
                        <div className="ringEnd">
                            <img src="images/so-19.png" alt="So 01" className="icon-img-style" style={{ height: hightScreen > 820 ? '80%' : '67%' }}/>
                        </div>
                        <div className="ringEnd">
                            <img src="images/so-6.png" alt="So 01" className="icon-img-style" />
                        </div>
                        <div className="ringEnd">
                            <img src="images/so-21.png" alt="So 01" className="icon-img-style" style={{ height: hightScreen > 820 ? '80%' : '67%' }}/>
                        </div>
                        <div className="ringEnd">
                            <img src="images/so-22.png" alt="So 01" className="icon-img-style" style={{ height: hightScreen > 820 ? '80%' : '67%' }}/>
                        </div>
                    </>
                );
            case 'ring3':
                return (
                    <>
                        <div className="ringEnd">
                            <img src="images/so-30.png" alt="So 01" className="icon-img-style" style={{ height: hightScreen > 820 ? '80%' : '67%' }}/>
                        </div>
                        <div className="ringEnd">
                            <img src="images/so-6.png" alt="So 01" className="icon-img-style" />
                        </div>
                        <div className="ringEnd">
                            <img src="images/so-31.png" alt="So 01" className="icon-img-style" style={{ height: hightScreen > 820 ? '80%' : '67%' }}/>
                        </div>
                        <div className="ringEnd">
                            <img src="images/so-33.png" alt="So 01" className="icon-img-style" style={{ height: hightScreen > 820 ? '80%' : '67%' }}/>
                        </div>
                    </>
                );
        }
        return (
            <>
                <div className="ringEnd">
                    <img src="images/so-0.png" alt="So 01" className="icon-img-style" style={{ height: hightScreen > 820 ? '80%' : '67%' }}/>
                </div>
                <div className="ringEnd">
                    <img src="images/so-6.png" alt="So 01" className="icon-img-style" />
                </div>
                <div className="ringEnd">
                    <img src="images/so-02.png" alt="So 01" className="icon-img-style" style={{ height: hightScreen > 820 ? '80%' : '67%' }}/>
                </div>
                <div className="ringEnd">
                    <img src="images/so-03.png" alt="So 01" className="icon-img-style" style={{ height: hightScreen > 820 ? '80%' : '67%' }}/>
                </div>
            </>
        );
    }

    else if (
        (props.ring1 === 7) ||
        (props.ring2 === 7) ||
        (props.ring3 === 7)
    ) {
        switch (props.type) {
            case 'ring1':
                return (
                    <>
                        <div className="ringEnd">
                            <img src="images/so-37.png" alt="So 01" className="icon-img-style" style={{ height: hightScreen > 820 ? '80%' : '67%' }}/>
                        </div>
                        <div className="ringEnd">
                            <img src="images/so-7.png" alt="So 01" className="icon-img-style" />
                        </div>
                        <div className="ringEnd">
                            <img src="images/so-35.png" alt="So 01" className="icon-img-style" style={{ height: hightScreen > 820 ? '80%' : '67%' }}/>
                        </div>
                        <div className="ringEnd">
                            <img src="images/so-34.png" alt="So 01" className="icon-img-style" style={{ height: hightScreen > 820 ? '80%' : '67%' }}/>
                        </div>
                    </>
                );
            case 'ring2':
                return (
                    <>
                        <div className="ringEnd">
                            <img src="images/so-19.png" alt="So 01" className="icon-img-style" style={{ height: hightScreen > 820 ? '80%' : '67%' }}/>
                        </div>
                        <div className="ringEnd">
                            <img src="images/so-7.png" alt="So 01" className="icon-img-style" />
                        </div>
                        <div className="ringEnd">
                            <img src="images/so-21.png" alt="So 01" className="icon-img-style" style={{ height: hightScreen > 820 ? '80%' : '67%' }}/>
                        </div>
                        <div className="ringEnd">
                            <img src="images/so-22.png" alt="So 01" className="icon-img-style" style={{ height: hightScreen > 820 ? '80%' : '67%' }}/>
                        </div>
                    </>
                );
            case 'ring3':
                return (
                    <>
                        <div className="ringEnd">
                            <img src="images/so-30.png" alt="So 01" className="icon-img-style" style={{ height: hightScreen > 820 ? '80%' : '67%' }}/>
                        </div>
                        <div className="ringEnd">
                            <img src="images/so-7.png" alt="So 01" className="icon-img-style" />
                        </div>
                        <div className="ringEnd">
                            <img src="images/so-31.png" alt="So 01" className="icon-img-style" style={{ height: hightScreen > 820 ? '80%' : '67%' }}/>
                        </div>
                        <div className="ringEnd">
                            <img src="images/so-33.png" alt="So 01" className="icon-img-style" style={{ height: hightScreen > 820 ? '80%' : '67%' }}/>
                        </div>
                    </>
                );
        }
        return (
            <>
                <div className="ringEnd">
                    <img src="images/so-0.png" alt="So 01" className="icon-img-style" style={{ height: hightScreen > 820 ? '80%' : '67%' }}/>
                </div>
                <div className="ringEnd">
                    <img src="images/so-7.png" alt="So 01" className="icon-img-style" />
                </div>
                <div className="ringEnd">
                    <img src="images/so-02.png" alt="So 01" className="icon-img-style" style={{ height: hightScreen > 820 ? '80%' : '67%' }}/>
                </div>
                <div className="ringEnd">
                    <img src="images/so-03.png" alt="So 01" className="icon-img-style" style={{ height: hightScreen > 820 ? '80%' : '67%' }}/>
                </div>
            </>
        );
    }

    else if (
        (props.ring1 === 8) ||
        (props.ring2 === 8) ||
        (props.ring3 === 8)
    ) {
        switch (props.type) {
            case 'ring1':
                return (
                    <>
                        <div className="ringEnd">
                            <img src="images/so-37.png" alt="So 01" className="icon-img-style" style={{ height: hightScreen > 820 ? '80%' : '67%' }}/>
                        </div>
                        <div className="ringEnd">
                            <img src="images/so-8.png" alt="So 01" className="icon-img-style" />
                        </div>
                        <div className="ringEnd">
                            <img src="images/so-35.png" alt="So 01" className="icon-img-style" style={{ height: hightScreen > 820 ? '80%' : '67%' }}/>
                        </div>
                        <div className="ringEnd">
                            <img src="images/so-34.png" alt="So 01" className="icon-img-style" style={{ height: hightScreen > 820 ? '80%' : '67%' }}/>
                        </div>
                    </>
                );
            case 'ring2':
                return (
                    <>
                        <div className="ringEnd">
                            <img src="images/so-19.png" alt="So 01" className="icon-img-style" style={{ height: hightScreen > 820 ? '80%' : '67%' }}/>
                        </div>
                        <div className="ringEnd">
                            <img src="images/so-8.png" alt="So 01" className="icon-img-style" />
                        </div>
                        <div className="ringEnd">
                            <img src="images/so-21.png" alt="So 01" className="icon-img-style" style={{ height: hightScreen > 820 ? '80%' : '67%' }}/>
                        </div>
                        <div className="ringEnd">
                            <img src="images/so-22.png" alt="So 01" className="icon-img-style" style={{ height: hightScreen > 820 ? '80%' : '67%' }}/>
                        </div>
                    </>
                );
            case 'ring3':
                return (
                    <>
                        <div className="ringEnd">
                            <img src="images/so-30.png" alt="So 01" className="icon-img-style" style={{ height: hightScreen > 820 ? '80%' : '67%' }}/>
                        </div>
                        <div className="ringEnd">
                            <img src="images/so-8.png" alt="So 01" className="icon-img-style" />
                        </div>
                        <div className="ringEnd">
                            <img src="images/so-31.png" alt="So 01" className="icon-img-style" style={{ height: hightScreen > 820 ? '80%' : '67%' }}/>
                        </div>
                        <div className="ringEnd">
                            <img src="images/so-33.png" alt="So 01" className="icon-img-style" style={{ height: hightScreen > 820 ? '80%' : '67%' }}/>
                        </div>
                    </>
                );
        }
        return (
            <>
                <div className="ringEnd">
                    <img src="images/so-0.png" alt="So 01" className="icon-img-style" style={{ height: hightScreen > 820 ? '80%' : '67%' }}/>
                </div>
                <div className="ringEnd">
                    <img src="images/so-9.png" alt="So 01" className="icon-img-style" />
                </div>
                <div className="ringEnd">
                    <img src="images/so-02.png" alt="So 01" className="icon-img-style" style={{ height: hightScreen > 820 ? '80%' : '67%' }}/>
                </div>
                <div className="ringEnd">
                    <img src="images/so-03.png" alt="So 01" className="icon-img-style" style={{ height: hightScreen > 820 ? '80%' : '67%' }}/>
                </div>
            </>
        );
    }

    else if (
        (props.ring1 === 9) ||
        (props.ring2 === 9) ||
        (props.ring3 === 9)
    ) {
        switch (props.type) {
            case 'ring1':
                return (
                    <>
                        <div className="ringEnd">
                            <img src="images/so-37.png" alt="So 01" className="icon-img-style" style={{ height: hightScreen > 820 ? '80%' : '67%' }}/>
                        </div>
                        <div className="ringEnd">
                            <img src="images/so-9.png" alt="So 01" className="icon-img-style" />
                        </div>
                        <div className="ringEnd">
                            <img src="images/so-35.png" alt="So 01" className="icon-img-style" style={{ height: hightScreen > 820 ? '80%' : '67%' }}/>
                        </div>
                        <div className="ringEnd">
                            <img src="images/so-34.png" alt="So 01" className="icon-img-style" style={{ height: hightScreen > 820 ? '80%' : '67%' }}/>
                        </div>
                    </>
                );
            case 'ring2':
                return (
                    <>
                        <div className="ringEnd">
                            <img src="images/so-19.png" alt="So 01" className="icon-img-style" style={{ height: hightScreen > 820 ? '80%' : '67%' }}/>
                        </div>
                        <div className="ringEnd">
                            <img src="images/so-9.png" alt="So 01" className="icon-img-style" />
                        </div>
                        <div className="ringEnd">
                            <img src="images/so-21.png" alt="So 01" className="icon-img-style" style={{ height: hightScreen > 820 ? '80%' : '67%' }}/>
                        </div>
                        <div className="ringEnd">
                            <img src="images/so-22.png" alt="So 01" className="icon-img-style" style={{ height: hightScreen > 820 ? '80%' : '67%' }}/>
                        </div>
                    </>
                );
            case 'ring3':
                return (
                    <>
                        <div className="ringEnd">
                            <img src="images/so-30.png" alt="So 01" className="icon-img-style" style={{ height: hightScreen > 820 ? '80%' : '67%' }}/>
                        </div>
                        <div className="ringEnd">
                            <img src="images/so-9.png" alt="So 01" className="icon-img-style" />
                        </div>
                        <div className="ringEnd">
                            <img src="images/so-31.png" alt="So 01" className="icon-img-style" style={{ height: hightScreen > 820 ? '80%' : '67%' }}/>
                        </div>
                        <div className="ringEnd">
                            <img src="images/so-33.png" alt="So 01" className="icon-img-style" style={{ height: hightScreen > 820 ? '80%' : '67%' }}/>
                        </div>
                    </>
                );
        }
        return (
            <>
                <div className="ringEnd">
                    <img src="images/so-0.png" alt="So 01" className="icon-img-style" style={{ height: hightScreen > 820 ? '80%' : '67%' }}/>
                </div>
                <div className="ringEnd">
                    <img src="images/so-9.png" alt="So 01" className="icon-img-style" />
                </div>
                <div className="ringEnd">
                    <img src="images/so-02.png" alt="So 01" className="icon-img-style" style={{ height: hightScreen > 820 ? '80%' : '67%' }}/>
                </div>
                <div className="ringEnd">
                    <img src="images/so-03.png" alt="So 01" className="icon-img-style" style={{ height: hightScreen > 820 ? '80%' : '67%' }}/>
                </div>
            </>
        );
    }

    else {
        return <> {ImgListInit}</>
    }
};
export default RowItemGame;
